<template>
  <div id="dashboard">
    <main-layout>
      <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
        <v-tab
          v-if="selectedBot.theme == 'sahapan'"
          ripple
          :key="'stat-customer'"
          :href="'#stat-customer'"
          >{{ $t('Customer Analytic') }}</v-tab
        >
        <v-tab v-if="isBU" ripple :key="'customers'" :href="'#customers'">
          {{ $t('Customer') }}
        </v-tab>
        <template
          v-if="
            selectedBot.theme != 'universalutilities' ||
            (selectedBot.theme == 'universalutilities' && $store.state.userid == 'uuadmin')
          "
        >
          <template v-if="isAiraAifulPage">
            <v-tab ripple :key="'overview'" :href="'#overview'">{{ $t('Dashboard') }}</v-tab>
          </template>
          <template v-else>
            <v-tab ripple :key="'stat-summary'" :href="'#stat-summary'">{{
              $t('Dashboard')
            }}</v-tab>
          </template>

          <v-tab ripple :key="'active-user-graph'" :href="'#active-user-graph'">{{
            $t('Metrics')
          }}</v-tab>
          <v-tab ripple :key="'summary-intent'" :href="'#summary-intent'">{{
            $t('Conversation')
          }}</v-tab>
        </template>

        <template v-if="['2428337527228612', '106728661059512'].includes(selectedBot.pageid)">
          <v-tab ripple :key="'neo-money-user-summary'" :href="'#neo-money-user-summary'">{{
            $t('User Summary')
          }}</v-tab>
        </template>

        <!-- New dashboard -->
        <template v-if="$store.state.newDeshboard.includes(selectedBot.pageid)">
          <v-tab ripple :key="'overview'" :href="'#overview'">
            {{ $t('Overview') }}
          </v-tab>
          <v-tab ripple :key="'inbox'" :href="'#inbox'">
            {{ $t('Inbox') }}
          </v-tab>
          <v-tab ripple :key="'comment'" :href="'#comment'">
            {{ $t('Comment') }}
          </v-tab>

          <v-tab ripple :key="'users'" :href="'#users'">
            {{ $t('Users') }}
          </v-tab>
        </template>

        <v-tab v-if="isBU" ripple :key="'customers'" :href="'#customers'">
          {{ $t('Customer') }}
        </v-tab>

        <v-tab
          v-if="isRussianRoulette"
          ripple
          :key="'RussianRouletteDashboard'"
          :href="'#RussianRouletteDashboard'"
          >{{ $t('Admin performance') }}</v-tab
        >
        <v-tab
          v-if="!isBU && !['kasikorncareer', 'sahapan'].includes(selectedBot.theme)"
          ripple
          :key="'customers'"
          :href="'#customers'"
          >{{ $t('Customer') }}</v-tab
        >
        <v-tab
          v-if="['sahapan'].includes(selectedBot.theme)"
          ripple
          :key="'SahapanCustomers'"
          :href="'#SahapanCustomers'"
          >{{ $t('Customer') }}</v-tab
        >
        <v-tab
          v-if="
            selectedBot.pageid == '105911105134578' ||
            selectedBot.pageid == '101931352240400' ||
            $store.state.pageListSingGaling.includes(selectedBot.pageid)
          "
          ripple
          :key="'Voteresult'"
          :href="'#Voteresult'"
        >
          VOTING RESULT
        </v-tab>
        <v-tab
          v-if="
            selectedBot.pageid == '105911105134578' ||
            selectedBot.pageid == '101931352240400' ||
            $store.state.pageListSingGaling.includes(selectedBot.pageid)
          "
          ripple
          :key="'Participants'"
          :href="'#Participants'"
        >
          PARTICIPANTS
        </v-tab>
        <v-tab
          v-if="selectedBot.theme == 'atomicboy'"
          ripple
          :key="'FalesQuestion'"
          :href="'#FalesQuestion'"
        >
          {{ $t('WRONG ANSWER REPORT') }}
        </v-tab>
        <v-tab
          v-if="['ramapoisoncenter'].includes(selectedBot.theme)"
          ripple
          :key="'RamapoisonCustomers'"
          :href="'#RamapoisonCustomers'"
          >{{ $t('Customer') }}</v-tab
        >
        <template v-if="selectedBot.theme == 'kasikorncareer'">
          <v-tab ripple :key="'customers'" :href="'#customers'">{{ $t('Career Matching') }}</v-tab>
          <v-tab ripple :key="'kasikorn-personality-test'" :href="'#kasikorn-personality-test'">{{
            $t('Personality Test')
          }}</v-tab>
          <v-tab ripple :key="'kasikorn-digital-skill'" :href="'#kasikorn-digital-skill'">{{
            $t('Digital Skill')
          }}</v-tab>
        </template>
        <v-tab
          ripple
          v-if="['generalixwarroom', 'generali'].includes(selectedBot.theme)"
          :key="'tag-report'"
          :href="'#tag-report'"
          >{{ $t('Tag') }}</v-tab
        >
        <v-tab ripple :key="'employee'" :href="'#employee'" v-if="selectedBot.theme == 'hafele'">{{
          $t('Employee')
        }}</v-tab>
        <v-tab
          ripple
          :key="'SahapanTopLocation'"
          :href="'#SahapanTopLocation'"
          v-if="selectedBot.theme == 'sahapan'"
          >{{ $t('Top Location') }}</v-tab
        >

        <v-tab
          ripple
          :key="'SahapanTopRewardPoint'"
          :href="'#SahapanTopRewardPoint'"
          v-if="selectedBot.theme == 'sahapan'"
          >{{ $t('Top Reward') }}</v-tab
        >

        <v-tab v-if="isBU" ripple :key="'inbox-stat-register'" :href="'#inbox-stat-register'">{{
          $t('Register')
        }}</v-tab>
        <v-tab v-if="isBU" ripple :key="'inbox-stat-faculty'" :href="'#inbox-stat-faculty'">{{
          $t('Faculty')
        }}</v-tab>
        <v-tab
          v-if="isBU"
          ripple
          :key="'inbox-stat-scholarships'"
          :href="'#inbox-stat-scholarships'"
          >{{ $t('Scholarships') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-dashboard'"
          :href="'#aston-dashboard'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('Aston') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-line-dashboard'"
          :href="'#aston-line-dashboard'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('AstonLine') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-outsource-dashboard'"
          :href="'#aston-outsource-dashboard'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('Outsource') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-dashboard-admin-message'"
          :href="'#aston-dashboard-admin-message'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('Admin message') }}</v-tab
        >
        <v-tab
          ripple
          :key="'AstonConversationRate'"
          :href="'#AstonConversationRate'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('Conversation Rate') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-dashboard-admin-timing'"
          :href="'#aston-dashboard-admin-timing'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('AdminTiming') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-dashboard-feedback'"
          :href="'#aston-dashboard-feedback'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('Feedback') }}</v-tab
        >
        <v-tab
          ripple
          :key="'ceemeagain'"
          :href="'#ceemeagain'"
          v-if="
            ['ceemeagain'].includes(selectedBot.theme) && $store.getters.getPackage == 'premium'
          "
          >{{ $t('Ceemeagain') }}</v-tab
        >
        <v-tab
          ripple
          :key="'superten-dashboard'"
          :href="'#superten-dashboard'"
          v-if="$store.state.supertenpage.includes(selectedBot.pageid)"
          >{{ $t('Vote') }}</v-tab
        >
        <v-tab
          ripple
          :key="'ScgdistributionInterest'"
          :href="'#ScgdistributionInterest'"
          v-if="['scgdistribution'].includes(selectedBot.theme)"
          >{{ $t('Check-in') }}</v-tab
        >
        <v-tab
          ripple
          :key="'atomic-student-summary'"
          :href="'#atomic-student-summary'"
          v-if="['102074341651763'].includes(selectedBot.pageid)"
          >{{ $t('Student Summary') }}</v-tab
        >
        <v-tab
          ripple
          :key="'voting-result'"
          :href="'#voting-result'"
          v-if="['tero'].includes(selectedBot.theme)"
          >{{ $t('Voting Result') }}</v-tab
        >
        <v-tab
          ripple
          :key="'participate'"
          :href="'#participate'"
          v-if="['tero'].includes(selectedBot.theme)"
          >{{ $t('Participants') }}</v-tab
        >
        <v-tab
          ripple
          :key="'EmployeeInfo'"
          :href="'#EmployeeInfo'"
          v-if="['centralhr'].includes(selectedBot.theme)"
          >{{ $t('Employee Summary') }}</v-tab
        >
        <v-tab
          ripple
          :key="'LamyBehaviorReport'"
          :href="'#LamyBehaviorReport'"
          v-if="[...$store.state.lamyPage].includes(selectedBot.pageid)"
          >{{ $t('Behavior Report') }}</v-tab
        >
        <v-tab
          ripple
          :key="'LamyWarranty'"
          :href="'#LamyWarranty'"
          v-if="[...$store.state.lamyPage].includes(selectedBot.pageid)"
          >{{ $t('Warranty') }}</v-tab
        >
        <v-tab
          ripple
          :key="'gpf-answer-report'"
          :href="'#gpf-answer-report'"
          v-if="selectedBot && selectedBot.type === 'gpf'"
          >{{ $t('answer_report') }}</v-tab
        >

        <v-tab ripple :key="'tags-and-status'" :href="'#tags-and-status'">{{
          $t('Tags/Status')
        }}</v-tab>
        <v-tab
          ripple
          :key="'conversation-details'"
          :href="'#conversation-details'"
          v-if="[...$store.state.toaPaintPage].includes(selectedBot.pageid)"
          >{{ $t('conversation_details') }}
        </v-tab>

        <v-tab
          v-if="selectedBot.theme == 'atomicboy'"
          ripple
          :key="'GameLevelReport'"
          :href="'#GameLevelReport'"
        >
          {{ $t('GAME LEVEL REPORT') }}
        </v-tab>
      </v-tabs>
      <template v-if="currentView == 'customers'">
        <template v-if="selectedBot.theme == 'universalutilities'">
          <component :is="'uu-customers'"></component>
        </template>
        <template v-else-if="selectedBot.theme == 'kasikorncareer'">
          <component :is="'kasikorn-career'"></component>
        </template>
        <template v-else-if="selectedBot.theme == 'atomicboy'">
          <component :is="'atomicboy-customers'"></component>
        </template>
        <template v-else-if="['toa'].includes(selectedBot.theme)">
          <component :is="'ToaCustomer'"></component>
        </template>

        <template v-else-if="['centralhr'].includes(selectedBot.theme)">
          <component :is="'CentralHRCustomer'"></component>
        </template>
        <template v-else>
          <component :is="currentView"></component>
        </template>
      </template>
      <template v-else-if="currentView == 'employee'">
        <component :is="'hafele-customers'"></component>
      </template>
      <template v-else-if="currentView == 'FalesQuestion'">
        <component :is="'AtomicboyFalesQuestion'"></component>
      </template>
      <template v-else-if="currentView == 'LamyBehaviorReport'">
        <component :is="'LamyBehaviorReport'"></component>
      </template>
      <template v-else-if="currentView == 'LamyWarranty'">
        <component :is="'LamyWarranty'"></component>
      </template>

      <!-- <template v-else-if="currentView == 'LamyWarranty'">
        <component :is="'LamyWarranty'"></component>
      </template> -->

      <template v-else-if="currentView == 'GameLevelReport'">
        <component :is="'AtomicboyGameLevelReport'"></component>
      </template>

      <template v-else>
        <component :is="currentView"></component>
      </template>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import numeral from 'numeral'

import SahapanCustomers from './SahapanCustomers'
import KasikornCareer from './KasikornCareer'
import UuCustomers from './UuCustomers'
import HafeleCustomers from './HafeleCustomers'
import ToaCustomer from './ToaCustomer.vue'
import AtomicboyCustomers from './AtomicboyCustomers.vue'
import AtomicboyFalesQuestion from './AtomicboyFalesQuestion.vue'
import AtomicboyGameLevelReport from './AtomicboyGameLevelReport.vue'

import KasikornPersonalityTest from './KasikornPersonalityTest'
import KasikornDigitalSkill from './KasikornDigitalSkill'
import RamapoisonCustomers from './RamapoisonCustomers.vue'
import Ceemeagain from './Ceemeagain.vue'

import TagReport from './TagReport.vue'
import SahapanTopLocation from './SahapanTopLocation.vue'
import SahapanTopRewardPoint from './SahapanTopRewardPoint.vue'
import StatCustomer from './StatCustomer.vue'
import StatSummary from './StatSummary.vue'
import ActiveUserGraph from './ActiveUserGraph.vue'
import Customers from './Customers.vue'
import SummaryIntent from './SummaryIntent.vue'
import InboxStatRegister from './InboxStatRegister.vue'
import InboxStatFaculty from './InboxStatFaculty.vue'
import InboxStatScholarships from './InboxStatScholarships.vue'
import AstonDashboard from './AstonDashboard.vue'
import AstonLineDashboard from './AstonLineDashboard.vue'
import AstonOutsourceDashboard from './AstonOutsourceDashboard.vue'
import AstonDashboardAdminMessage from './AstonDashboardAdminMessage.vue'
import AstonDashboardAdminTiming from './AstonDashboardAdminTiming.vue'
import AstonDashboardFeedback from './AstonDashboardFeedback.vue'
import RussianRouletteDashboard from './RussianRouletteDashboard.vue'
import AstonConversationRate from './AstonConversationRate.vue'
import NeoMoneyUserSummary from './NeoMoneyUserSummary.vue'
import BranchLocation from './BranchLocation.vue'
import SupertenDashboard from './SupertenDashboard.vue'
import AtomicStudentSummary from './AtomicStudentSummary.vue'
import CentralHRCustomer from './centralhr/CentralHRCustomer.vue'
import EmployeeInfo from './centralhr/EmployeeInfo.vue'
import VotingResult from './tero/VotingResult.vue'
import Participate from './tero/Participate.vue'
import ScgdistributionInterest from './ScgdistributionInterest.vue'
import Participants from './Participants.vue'
import Voteresult from './Voteresult.vue'
import LamyWarranty from './lamy/LamyWarranty.vue'
import LamyBehaviorReport from './lamy/LamyBehaviorReport.vue'
import TagsAndStatus from './TagsAndStatus.vue'
import ConversationDetails from './toapaint/ConversationDetails.vue'
import GpfAnswerReport from './GpfAnswerReport.vue'

import Overview from './Overview.vue'
import { PAGE } from '@/constants/page.js'
export default {
  data: function () {
    return {
      showIntent: false,
      currentView: ''
    }
  },
  components: {
    AtomicboyGameLevelReport,
    AtomicboyFalesQuestion,
    StatSummary,
    ToaCustomer,
    AstonDashboard,
    AstonLineDashboard,
    ActiveUserGraph,
    SummaryIntent,
    Customers,
    UuCustomers,
    KasikornCareer,
    HafeleCustomers,
    AtomicboyCustomers,
    TagReport,
    InboxStatRegister,
    InboxStatFaculty,
    AstonOutsourceDashboard,
    InboxStatScholarships,
    KasikornPersonalityTest,
    KasikornDigitalSkill,
    StatCustomer,
    AstonDashboardAdminMessage,
    AstonDashboardAdminTiming,
    AstonDashboardFeedback,
    SahapanTopLocation,
    SahapanTopRewardPoint,
    RussianRouletteDashboard,
    SahapanCustomers,
    NeoMoneyUserSummary,
    AstonConversationRate,
    RamapoisonCustomers,
    Ceemeagain,
    BranchLocation,
    SupertenDashboard,
    AtomicStudentSummary,
    CentralHRCustomer,
    VotingResult,
    Participate,
    EmployeeInfo,
    ScgdistributionInterest,
    Participants,
    Voteresult,
    LamyWarranty,
    LamyBehaviorReport,
    TagsAndStatus,
    ConversationDetails,
    GpfAnswerReport,
    Overview
  },
  created: function () {
    let vm = this
    if (vm.$route.query.tab) {
      // switch (vm.$route.query.tab) {
      //   case 'statistic':
      //   case 'crm':
      //   case 'custom_analytic':
      //     vm.currentView = vm.$route.query.tab
      //     break
      //   default:
      //     vm.currentView = 'statistic'
      //     break
      // }
      vm.currentView = vm.$route.query.tab
    } else {
      if (this.selectedBot.theme == 'universalutilities' && this.$store.state.userid != 'uuadmin') {
        vm.currentView = 'customers'
      } else if (this.isAiraAifulPage) {
        vm.currentView = 'overview'
      } else {
        vm.currentView = 'stat-summary'
      }
    }
  },
  mounted: function () {},
  computed: {
    astonpages() {
      return this.$aston.astonpages
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    isRussianRoulette() {
      return this.$store.state.pageRussianRoulette.includes(this.selectedBot.pageid)
    },
    isAiraAifulPage() {
      return PAGE.AIRA_AIFUL.includes(this.selectedBot.pageid)
    }
  },
  methods: {
    numberFormat: function (val) {
      return numeral(val).format('0,0')
    },
    updateRoute: function () {
      this.$router
        .push({
          name: 'dashboard',
          path: '/dashboard',
          query: {
            tab: this.currentView
          }
        })
        .catch(() => {})
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/Dashboard.vue